const getIsDeleted = ({permission} = {}) => {
  const userPermission = typeof permission === 'object' ? permission.permission : permission;
  return typeof userPermission === 'undefined' ? true : userPermission === 'deleted';
};

export default getIsDeleted;
